import { render, staticRenderFns } from "./Arte.vue?vue&type=template&id=c3efff6e&scoped=true&"
import script from "./Arte.vue?vue&type=script&lang=js&"
export * from "./Arte.vue?vue&type=script&lang=js&"
import style0 from "./Arte.vue?vue&type=style&index=0&id=c3efff6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3efff6e",
  null
  
)

export default component.exports